module.exports = __webpack_public_path__ + "img/velocidad_viento_h.f7133686.png";